import { useCallback, useEffect } from 'react';

import { TRACK_TYPE } from '../VBaseTrack';
import { SLIDER_THUMB_SIZE } from './constant';
import { useVSliderContext } from './hook';
import {
  changeAllFilledTrack,
  changeFilledTrackEl,
  getFilledTrackElByValue,
} from './util';

export const VSliderFilledTrackList = () => {
  const {
    eventEmitter,
    normalizedMarkerItemMap,
    normalizedValue,
    max,
    min,
    step,
    style,
    type,
    variant,
    $track,
  } = useVSliderContext();

  const memoChangeAllFilledTrack = useCallback(
    () =>
      normalizedMarkerItemMap
        ? changeAllFilledTrack({
            normalizedMarkerItemMap,
            max,
            min,
            step,
            type: type!,
            variant,
            $track,
          })
        : void 0,
    [normalizedMarkerItemMap, max, min, step, type, variant, $track],
  );

  useEffect(() => {
    if (!$track.current) return;

    memoChangeAllFilledTrack();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memoChangeAllFilledTrack]);

  useEffect(() => {
    eventEmitter.on('thumbMove', (event: any) => {
      if (!(event.trigger instanceof HTMLDivElement))
        return memoChangeAllFilledTrack();

      const { reversed, thumbTx, thumbValue } = event.target;
      const tx = thumbTx + (SLIDER_THUMB_SIZE >> 1);
      const $filledTrack = getFilledTrackElByValue($track, thumbValue);

      if (!$filledTrack) return;

      const isStartThumb =
        type !== TRACK_TYPE.NORMAL && $filledTrack.ariaValueMin! == thumbValue;
      const endOrgLeft = +$filledTrack.style.getPropertyValue('--endOrgLeft');
      const startOrgLeft =
        +$filledTrack.style.getPropertyValue('--startOrgLeft');

      if ((isStartThumb && !reversed) || (!isStartThumb && reversed)) {
        changeFilledTrackEl({
          $filledTrack,
          endLeft: reversed ? startOrgLeft : endOrgLeft,
          startLeft: tx,
          variant,
        });
      } else {
        changeFilledTrackEl({
          $filledTrack,
          endLeft: tx,
          startLeft: reversed ? endOrgLeft : startOrgLeft,
          variant,
        });
      }
    });

    return () => {
      eventEmitter.off('thumbMove');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [normalizedValue, type, variant, memoChangeAllFilledTrack]);

  return (
    <>
      {normalizedValue.map(([start, end], i) => {
        if (end == null) {
          [start, end] = [min, start];
        }

        return (
          <div
            key={i}
            aria-label="v-slider-filled-track"
            aria-valuemax={end}
            aria-valuemin={start}
            className={style.filledTrack}
            style={
              {
                '--endLeft': 0,
                '--startLeft': 0,
              } as React.CSSProperties
            }
          />
        );
      })}
    </>
  );
};
